import { createApp } from 'vue'
import Questionnaire from './components/Questionnaire.vue'

createApp(Questionnaire).mount('#app')
